/* eslint-disable react/require-default-props */
import React from 'react';
import { colors } from '@/styles';

export type ImagePlaceholderProps = {
  className?: string;
  fill?: string;
  title?: string;
};

export function ImagePlaceholder({
  className = 'placeholder',
  fill = colors.silverSand,
  title = 'image placeholder',
}: ImagePlaceholderProps) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.63 21.61">
      {Boolean(title) && <title>{title}</title>}
      <polygon points="9.99 6.55 9.99 6.55 9.99 6.55 9.99 6.55" fill={fill} />
      <path d="M7.9,8.66H8a2,2,0,0,0,2-2.11v0A2.12,2.12,0,1,0,7.9,8.66Z" fill={fill} />
      <path
        d="M0,0V21.61H30.63V0ZM29.63,1V20.38q-4.95-6.75-9.95-13.49a1,1,0,0,0-.32-.32,1,1,0,0,0-1.4.32l-6.14,8.32c-.18.25-.4.47-.63.73a3.82,3.82,0,0,1-.3-.31c-.71-.94-1.39-1.91-2.12-2.83s-1.61-1-2.38,0L3.75,16.42,1,20.18V1Z"
        fill={fill}
      />
    </svg>
  );
}
